import CsSideMenu from './CsSideMenu.vue'
CsSideMenu.install = function (Vue) {
  Vue.component(CsSideMenu.name, CsSideMenu)
}
export default CsSideMenu


// WEBPACK FOOTER //
// ./src/components/sideMenu/index.js